import {
  Box,
  SpaceBetween,
  SpaceBetweenProps,
} from "@cloudscape-design/components-themed";
import TextContent from "@cloudscape-design/components-themed/text-content";

interface IInfoField extends SpaceBetweenProps {
  tag: keyof JSX.IntrinsicElements;
  values: (string | null | undefined)[];
}

/**
 * 受け取った項目リストを表示する.
 * ただし、false値は空白を表示する.
 */
const InfoField = (props: IInfoField) => {
  const { tag: Tag, values, ...spaceBetweenProps } = props;

  return (
    <SpaceBetween {...spaceBetweenProps}>
      {values.map((element, elIndex) => (
        <Box key={elIndex}>
          {element ? (
            <>
              {element.split("\r\n").map((line, index) => (
                <TextContent key={`${line}-${index}`}>
                  <Tag>{line}</Tag>
                </TextContent>
              ))}
            </>
          ) : (
            <>{"　"}</>
          )}
        </Box>
      ))}
    </SpaceBetween>
  );
};

export default InfoField;
